import ApiService from './ApiService';
import { ADMIN_LOGIN_URL } from './apiConfig';
// import ToastService from '../services/ToastService';

class AuthService {

  constructor(router) {
    this.router = router; // Store the router instance
  }

  async login(email, password) {
    try {
      const response = await ApiService.request({
        method: 'POST',
        url: '/login',
        data: { email, password },
      });

      return response.data;
    } catch (error) {
      // Handle the error, you might want to show a toast notification or similar
      // return error.response.data;
    }
  }

  logout() {
    localStorage.removeItem('admin');
    localStorage.removeItem('permissions');
    window.location.href = ADMIN_LOGIN_URL;
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('admin'));
  }
}

const authServiceInstance = new AuthService(/* pass your router instance here */);
export default authServiceInstance;
